export default __webpack_public_path__ + "static/iosapp-ad9f212b33c3a81805d2ede2cf1baa15.webp";